import React, { Component } from 'react';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { CardInfoChange } from 'components/person/CardInfoChange';
import { SubscriptionTypeChange } from 'components/assinatura/SubscriptionTypeChange';
import { CancelChangeOfPlan } from 'components/assinatura/CancelChangeOfPlan';
import { Modal } from 'components/modal/Modal';
import { AddressChange } from 'components/person/AddressChange';
import { Container } from 'components/grid/Container';
import { Row } from 'components/grid/Row';
import { Col } from 'components/grid/Col';
import { connect } from 'react-redux';
import { PaymentHistory } from 'components/pagamento/PaymentHistory';
import { RecurrenceChange } from 'components/pagamento/RecurrenceChange';
import { Utils } from 'utils/Utils';
import { Toggle } from 'components/general/Toggle';
import { AssinaturaRenovar } from 'components/assinatura/AssinaturaRenovar';
import { UiActions } from 'state/actions/UiActions';
import { CreditCardInput } from 'components/general/CreditCardInput';

import { Amex } from 'components/creditcard/Amex';
import { Diners } from 'components/creditcard/Diners';
import { Elo } from 'components/creditcard/Elo';
import { Aura } from 'components/creditcard/Aura';
import { Hipercard } from 'components/creditcard/Hipercard';
import { Mastercard } from 'components/creditcard/Mastercard';
import { Visa } from 'components/creditcard/Visa';
import { Discover } from 'components/creditcard/Discover';
import { Jcb } from 'components/creditcard/Jcb';
import { PaymentActions } from 'state/actions/user/PaymentActions';
import { CreditCardActions } from 'state/actions/user/CreditCardActions';
import { SubscriberStatus } from 'core/utils/SubscriberUtils';
import { DatetimeToLocaleDate } from 'core/utils/Utils';
import { AddressControl } from '../../controls/AddressControl';
import { BillingAddressControl } from '../../controls/BillingAddressControl';
import { Recurrence } from 'components/pagamento/Recurrence';

class AssinaturaDetalhes2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subscriberId: this.props.subscriberId,
      subscriptionId: 1,
      subscriptionInfo: this.props.subscriptionInfo,
      creditCardInfo: null,
      planInfo: null,
      subscriberDetail: null,
      recurrence: null,
      payment: null,

      recurrenceIsActive: false,
      currentSelectedPlan: null,
      renewalIsSet: false,

      subscriberStatusToFilter: 0,

      cardModalVisible: false,
      shippingModalVisible: false,
      billingModalVisible: false,
      planModalVisible: false,
      cancelChangeOfPlanModalVisible: false,
      recurrenceModalVisible: false,
      renewModalVisible: false,

      pending: false,
      loadError: false,
      loadErrorMessage: '',
    };

    this.toggleCardModal = this.toggleCardModal.bind(this);
    this.toggleShippingModal = this.toggleShippingModal.bind(this);
    this.toggleBillingModal = this.toggleBillingModal.bind(this);
    this.togglePlanModal = this.togglePlanModal.bind(this);
    this.toggleCancelChangeOfPlanModal = this.toggleCancelChangeOfPlanModal.bind(this);
    this.toggleRecurrenceModal = this.toggleRecurrenceModal.bind(this);

    this.updateAddressData = this.updateAddressData.bind(this);
    this.updateCardData = this.updateCardData.bind(this);
  }

  setTypeChangePlan = (planId) => {
    this.setState({
      currentSelectedPlan: planId,
    });
  };

  toggleRenewModal = () => {
    this.setState({
      renewModalVisible: !this.state.renewModalVisible,
    });
  };

  toggleCardModal() {
    this.setState({
      cardModalVisible: !this.state.cardModalVisible,
    });
  }

  toggleShippingModal() {
    this.setState({
      shippingModalVisible: !this.state.shippingModalVisible,
    });
  }

  toggleBillingModal() {
    this.setState({
      billingModalVisible: !this.state.billingModalVisible,
    });
  }

  togglePlanModal() {
    this.setState({
      planModalVisible: !this.state.planModalVisible,
      recurrenceModalVisible: false,
    });
  }

  toggleCancelChangeOfPlanModal() {
    this.setState({
      cancelChangeOfPlanModalVisible: !this.state.cancelChangeOfPlanModalVisible,
    });
  }

  toggleRecurrenceModal() {
    this.setState({
      recurrenceModalVisible: !this.state.recurrenceModalVisible,
    });
  }

  recurrenceFinished = (recurrenceIsActive) => {
    this.setState(
      {
        recurrenceIsActive,
        payment: null,
      },
      () => {
        this.getPaymentStatus();
        this.toggleRecurrenceModal();
      }
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.subscriberId !== this.props.subscriberId ||
      prevProps.subscriptionInfo.id !== this.props.subscriptionInfo.id
    ) {
      this.setState(
        {
          subscriberId: this.props.subscriberId,
          subscriptionId: this.props.subscriptionInfo,
        },
        () => {
          this.props.loadingStatusSet(true);

          this.setState({
            pending: true,
          });

          this.getSubscriberDetail();
        }
      );
    }
  }

  componentDidMount() {
    let { props } = this;

    props.loadingStatusSet(true);

    this.setState({
      pending: true,
    });

    this.getSubscriberDetail();
  }

  getCreditCardInfo = async () => {
    let token = this.props.token.Authorization;
    let subscriberId = this.props.subscriberId;

    this.props.loaderShow();

    if (subscriberId > 0) {
      await ExecuteRequest(
        GlamboxEndpoints.Subscriber.creditCard,
        {
          subscriberId: subscriberId,
        },
        'GET',
        {
          Authorization: token,
        },
        null,
        (response) => {
          const { result, statusCode } = response;
          this.props.loaderHide();

          if (statusCode === 200) {
            this.setState({
              creditCardInfo: result,
              pending: false,
            });
          } else {
            this.setState({
              pending: false,
              loadError: true,
              loadErrorMessage: result && result.message ? result.message : 'Erro desconhecido.',
            });
          }
        }
      );
    } else {
      this.props.loaderHide();
      return null;
    }
  };

  syncPayment = () => {
    this.getSubscriberDetail();
  };

  getPaymentStatus = async () => {
    let subscriberId = this.props.subscriberId;
    let token = this.props.token.Authorization;

    this.props.loaderShow();

    if (
      subscriberId > 0
      // && this.state.subscriberDetail.subscriberStatus === this.state.subscriberStatusToFilter
    ) {
      let response = await ExecuteRequest(
        GlamboxEndpoints.Subscriber.paymentStatus,
        {
          subscriberId: subscriberId,
        },
        'GET',
        {
          Authorization: token,
        },
        null
      );

      const { result, statusCode } = response;

      this.props.loaderHide();

      if (statusCode === 200) {
        this.props.loaderHide();

        let recurrenceIsActive =
          result.recurrence && result.recurrence.recurrenceStatusId === 0 ? true : false;

        let { renewal } = result;

        let newSubscriptionTypeId = this.scheduledSubscriptionTypeId(renewal);
        this.setState(
          {
            recurrenceIsActive: recurrenceIsActive,
            payment: result,
            renewalIsSet: newSubscriptionTypeId !== null,
            currentSelectedPlan: newSubscriptionTypeId,
            pending: false,
          },
          () => this.getCreditCardInfo()
        );
      } else {
        this.setState({
          pending: false,
          loadError: true,
          loadErrorMessage: result && result.message ? result.message : 'Erro desconhecido.',
        });

        this.props.loaderHide();
      }
    } else {
      this.props.loaderHide();
    }
  };

  getSubscriberDetail = () => {
    let token = this.props.token.Authorization;

    this.props.loaderShow();

    ExecuteRequest(
      GlamboxEndpoints.Subscriber.detail,
      null,
      'GET',
      {
        Authorization: token,
      },
      {
        subscriberId: this.props.subscriberId,
      },
      (response) => {
        const { result, statusCode } = response;

        this.props.loadingStatusSet(false);

        if (statusCode === 200) {
          this.setState(
            {
              subscriberDetail: result.subscriber,
              pending: false,
            },
            () => {
              this.props.loaderHide();

              this.getPaymentStatus();
            }
          );
        } else {
          this.props.loaderHide();

          this.setState({
            pending: false,
            loadError: true,
            loadErrorMessage: result && result.message ? result.message : 'Erro desconhecido.',
          });
        }
      }
    );
  };

  scheduledSubscriptionTypeId = (renewal) => {
    if (
      renewal !== null &&
      renewal.status === 1 &&
      renewal.newSubscriptionTypeId !== this.state.subscriptionInfo.subscriptionTypeId
    ) {
      return renewal.newSubscriptionTypeId;
    }
    return null;
  };

  changeOfPlanAction = (action) => {
    this.setState({
      renewalIsSet: action === 'changed',
    });
  };

  updateAddressData(addressData) {
    this.setState({
      subscriptionInfo: Object.assign({}, this.state.subscriptionInfo, addressData),
    });
    this.props.callback(addressData);
  }

  updateCardData(cardData) {
    let requestData = {
      creditCardName: cardData.nameOnCard,
      creditCardNumber: cardData.number,
      creditCardCVV: cardData.cvv,
      creditCardFlagId: cardData.flagId,
      creditCardExpirationMonth: cardData.expMonth,
      creditCardExpirationYear: cardData.expYear,
      subscriberId: this.props.subscriberId,
    };

    ExecuteRequest(
      GlamboxEndpoints.Subscriber.changeCreditCard,
      requestData,
      'PUT',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      (response) => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.getCreditCardInfo();
          this.props.successAlert(
            result && result.message ? result.message : 'Cartão de crédito alterado com sucesso.'
          );
        }

        this.toggleCardModal();
      }
    );
  }

  renderCardFlag = () => {
    if (!this.state.payment.recurrence) return null;

    switch (this.state.payment.recurrence.creditCardFlagId) {
      case 1:
        return <Visa size={63} />;
      case 2:
        return <Mastercard size={63} />;
      case 3:
        return <Amex size={63} />;
      case 4:
        return <Diners size={63} />;
      case 5:
        return <Hipercard size={63} />;
      case 6:
        return <Elo size={63} />;
      case 7:
        return <Discover size={63} />;
      case 8:
        return <Aura size={63} />;
      case 9:
        return <Jcb size={63} />;
      default:
        return null;
    }
  };

  showValidationMessage = () => {
    const validationMessage = this.state.validationMessage;
    return <h3>{validationMessage}</h3>;
  };

  renderCreditCardInfo = () => {
    let { creditCardInfo, recurrenceIsActive, subscriberDetail, payment } = this.state;

    if (
      !payment ||
      (!creditCardInfo && payment.recurrenceType !== 'braspag') ||
      subscriberDetail.subscriberStatus !== this.state.subscriberStatusToFilter
    ) {
      return null;
    }

    if (creditCardInfo === null) {
      creditCardInfo = {
        number: 'Adicione um Cartão',
        expYear: 2023,
        expMonth: 11,
        flag: '',
        nameOnCard: '',
      };
    }
    let nextPaymentDate = payment.recurrence.nextAttemptDate
      ? payment.recurrence.nextAttemptDate
      : payment.recurrence.nextPaymentDate;

    return (
      <div className={'gb-contentblock mb-4 mb-lg-0'}>
        <div
          className={
            'gb-contentblock p-4 level-2 mb-4 mb-lg-0 d-flex justify-between flex-md-row flex-column align-items-center cardInfo'
          }
        >
          <div>
            <small className={'small d-block'}>Cartão de Crédito</small>
            {nextPaymentDate && (
              <p>
                Data da próxima recorrência:
                <span> {DatetimeToLocaleDate(nextPaymentDate)}</span>
              </p>
            )}
            <p>Clique no cartão para alterar/adicionar.</p>

            {this.showValidationMessage()}
          </div>

          <button className={'credit-card__change'} onClick={this.toggleCardModal}>
            <span className={'credit-card__change-flag'}>{this.renderCardFlag()}</span>
            <span className={'credit-card__change-text'}>
              <span className={'number'}>{creditCardInfo.number}</span>
              <span className={'expiry'}>
                Expira em: {creditCardInfo.expMonth}/{creditCardInfo.expYear}
              </span>
            </span>
          </button>
        </div>

        <div
          className={
            'gb-contentblock p-4 level-2 mb-4 mb-lg-0 d-flex justify-between align-items-center'
          }
          style={{
            background: '#f9fafd',
            borderTop: '1px solid #e4e8ec',
            display: 'flex',
          }}
        >
          <div style={{ marginTop: '0' }}>
            <Toggle onClick={this.toggleRecurrenceModal} checked={recurrenceIsActive} />
          </div>
          <div style={{ width: 'calc(100% - 80px)' }}>
            <span>
              Renovação automática: <strong>{recurrenceIsActive ? 'Ativa' : 'Desativada'}</strong>
            </span>
            <p
              style={{
                fontSize: '13px',
                marginTop: '10px',
                lineHeight: '1.35em',
              }}
            >
              {recurrenceIsActive
                ? null
                : 'Seu pagamento não é recorrente e a assinatura será expirada caso a recorrência não seja habilitada'}
            </p>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { creditCardInfo, recurrenceIsActive, subscriberDetail, payment } = this.state;
    const { subscriptionInfo } = this.props;

    let currentView = null,
      recurrence = null;

    if (!subscriptionInfo || !subscriberDetail) return null;

    if (!!payment) recurrence = payment.recurrence;

    if (this.state.pending) {
      return (
        <div className={'p-2 p-lg-5 text-center'}>
          <p>Carregando...</p>
        </div>
      );
    }

    let subsTypeName = '';
    // const subsTypeName = subscriberDetail.subscriptionTypeName;
    switch (subscriberDetail.subscriptionTypeId) {
      case 1:
        subsTypeName = 'mensal';
        break;
      case 3:
        subsTypeName = 'semestral';
        break;
      default:
        subsTypeName = 'anual';
    }

    return (
      <div>
        <div className={'gb-contentblock mb-4'}>
          <div
            className={
              'gb-contentblock p-4 level-2 mb-4 mb-lg-0 d-flex justify-between flex-md-row flex-column align-items-center planInfo'
            }
          >
            <div>
              <h2>Assinatura {subsTypeName}</h2>
              <p>
                Plano {SubscriberStatus(subscriberDetail.subscriberStatus)} (criada em{' '}
                {DatetimeToLocaleDate(subscriberDetail.dateCreated)})
              </p>
            </div>

            {this.renderChangePlanMessage()}

            {this.renderPlanChangeButtons()}

            {this.renderRenewButton()}
          </div>
        </div>

        <Container fluid className={'assinatura-container'}>
          <Row className={'mb-4'}>
            <Col xs={12} lg={12}>
              {this.renderCreditCardInfo()}
            </Col>
            {/* <Col xs={12} lg={6}>
              <div className={"gb-contentblock mb-4 mb-lg-0"}>
                <div className={"gb-contentblock p-4 level-2 mb-0 mb-lg-0 d-flex justify-between flex-md-row flex-column align-items-center address-content"}>
                  <div>
                    <small className={"small d-block"}>Endereço de entrega</small>
                    <p>
                      {subscriptionInfo.shippingstreet},&nbsp;{subscriptionInfo.shippingStreetNumber}&nbsp;-&nbsp;{subscriptionInfo.shippingStreetExtensions}<br />{subscriptionInfo.shippingNeighborhood}&nbsp;-&nbsp;{subscriptionInfo.shippingCity}/{subscriptionInfo.shippingstate}  <br />CEP:&nbsp;{subscriptionInfo.shippingPostalCode}
                    </p>
                  </div>
                  <button className={"btn btn-sm btn-light-pink"} onClick={this.toggleShippingModal}>
                    Atualizar
                  </button>
                </div>
                <div className={"gb-contentblock p-4 level-2 mb-4 mb-lg-0 d-flex justify-between align-items-center address-content"}>
                  <div>
                    <small className={"small d-block"}>Endereço de cobrança</small>
                    <p>
                      {subscriberDetail.billingStreet},&nbsp;{subscriberDetail.billingStreetNumber}&nbsp;-&nbsp;{subscriberDetail.billingStreetExtensions}<br />{subscriberDetail.billingNeighborhood}&nbsp;-&nbsp;{subscriberDetail.billingCity}/{subscriberDetail.billingState}<br />CEP:&nbsp;{subscriberDetail.billingPostalCode}
                    </p>
                  </div>
                </div>
              </div>
            </Col> */}
          </Row>

          <Row>
            <Col xs={12} lg={12}>
              <div className={'gb-contentblock level-2'}>
                <div className={'gb-contentblock d-flex justify-between align-items-center'}>
                  <PaymentHistory subscriptionInfo={subscriptionInfo}></PaymentHistory>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {/* ------MODAIS------ */}
        {/* Abre a modal de troca de cartão 
          Passa o retorno do request + o SubscirberId da Url*/}
        <Modal visible={this.state.cardModalVisible} onCloseModal={this.toggleCardModal}>
          <CreditCardInput onSave={this.updateCardData} onCancel={this.toggleCardModal} />
        </Modal>

        <Modal visible={this.state.shippingModalVisible} onCloseModal={this.toggleShippingModal}>
          <h3>Endereço de Entrega</h3>
          <AddressChange
            subscriptionInfo={subscriptionInfo}
            type={1}
            onCloseModal={this.toggleShippingModal}
            callback={this.updateAddressData}
          />
        </Modal>

        <Modal
          visible={this.state.recurrenceModalVisible}
          onCloseModal={this.toggleRecurrenceModal}
        >
          <Recurrence
            token={this.props.token.Authorization}
            person={this.props.person}
            isActive={this.state.recurrenceIsActive}
            subscriber={this.state.subscriberDetail}
            recurrenceInfo={recurrence}
            onFinish={this.recurrenceFinished}
            onChangePlan={this.togglePlanModal}
          />
        </Modal>

        <Modal
          visible={this.state.planModalVisible}
          onCloseModal={this.togglePlanModal}
          useDefaultDialog={false}
          id="modal_troca_plano"
        >
          <div className={'modal_troca_plano__content'}>
            <h3>Vai mudar de Plano?</h3>
            <div className={'modal_troca_plano__content-body'}>
              <SubscriptionTypeChange
                subscriptionInfo={subscriptionInfo}
                onCloseModal={this.togglePlanModal}
                callback={this.changeOfPlanAction}
                selectedPlanType={this.state.currentSelectedPlan}
                parentPlanChange={this.setTypeChangePlan}
              ></SubscriptionTypeChange>
            </div>
          </div>
        </Modal>

        <Modal
          visible={this.state.cancelChangeOfPlanModalVisible}
          onCloseModal={this.toggleCancelChangeOfPlanModal}
        >
          <CancelChangeOfPlan
            subscriberId={this.props.subscriberId}
            onCloseModal={this.toggleCancelChangeOfPlanModal}
            callback={this.changeOfPlanAction}
          />
        </Modal>

        <Modal
          visible={this.state.renewModalVisible}
          onCloseModal={this.toggleRenewModal}
          useDefaultDialog={false}
        >
          <AssinaturaRenovar
            creditCardInfo={this.state.creditCardInfo}
            subscriberId={this.props.subscriberId}
            personId={this.props.person.personId}
            onCancel={this.toggleRenewModal}
            onCloseModal={this.toggleRenewModal}
            callback={this.syncPayment}
          />
        </Modal>
      </div>
    );
  }

  // ----------
  renderRenewButton = () => {
    if (
      !this.state.renewalIsSet &&
      this.state.subscriberDetail.subscriberStatus !== this.state.subscriberStatusToFilter
    ) {
      if (
        this.props.partnerInfo !== null &&
        this.props.partnerInfo.influencerStatus === 'Glampartner'
      ) {
        return null;
      }

      return (
        <button className={'btn btn-md btn-light-lime'} onClick={this.toggleRenewModal}>
          Reativar Assinatura
        </button>
      );
    } else {
      return null;
    }
  };

  renderChangePlanMessage = () => {
    let currentPlan,
      recurrenceMessage = null;

    if (!this.state.renewalIsSet) return null;

    switch (this.state.currentSelectedPlan) {
      case 1:
        currentPlan = 'Mensal';
        break;
      case 2:
        currentPlan = 'Anual';
        break;
      case 3:
        currentPlan = 'Semestral';
        break;
    }

    if (!this.state.recurrenceIsActive) {
      recurrenceMessage = (
        <p className={'lead'}>Não se esqueça de habilitar a renovação automática!</p>
      );
    }

    return (
      <div>
        <h5>Troca de Plano</h5>
        <p>
          Seu plano será trocado para <strong>{currentPlan}</strong> na sua próxima cobrança.
        </p>
        {recurrenceMessage}
      </div>
    );
  };

  renderPlanChangeButtons = () => {
    let buttons = [];

    if (this.props.partnerGeneral !== null) return null;

    if (this.state.renewalIsSet === true) {
      buttons.push(
        <button
          key={'btn-troca'}
          className={'btn btn-sm btn-light-lime text-no-wrap'}
          onClick={this.togglePlanModal}
        >
          Editar Troca
        </button>
      );

      buttons.push(
        <button
          key={'btn-cancel'}
          onClick={this.toggleCancelChangeOfPlanModal}
          className={'btn btn-sm btn-light-pink'}
        >
          Cancelar
        </button>
      );
    } else if (
      this.state.subscriberDetail.subscriberStatus === this.state.subscriberStatusToFilter
    ) {
      buttons.push(
        <button
          key={'btn-change'}
          className={'btn btn-sm btn-light-lime text-no-wrap'}
          onClick={this.togglePlanModal}
        >
          Trocar Plano
        </button>
      );
    }

    return buttons;
  };
}

const mapStateToProps = (state) => ({
  token: state.token.data,
  person: state.person.data,
  partnerInfo: state.partnerInfo.data,
  partnerGeneral: state.partnerGeneral.data,
  payment: state.payment.data,
  creditCardInfo: state.creditCardInfo.data,
});

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message));
    },
    errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message));
    },
    loaderHide: () => {
      dispatch(UiActions.loaderHide());
    },
    loaderShow: () => {
      dispatch(UiActions.loaderShow());
    },
    loadingStatusSet: (status) => {
      dispatch(UiActions.setLoadingStatus(status));
    },
  };
};

AssinaturaDetalhes2 = connect(mapStateToProps, mapDispatchToProps)(AssinaturaDetalhes2);

export { AssinaturaDetalhes2 };
